import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency, buildEntornoLaboralProps } from "../SheetLayout";

const CompensacionSLD: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const compensacionSLDId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getCompensationSld, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getCompensationSld(userId, prestacionId, compensacionSLDId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Compensación SLD"
        icon="euro"
        pills={<>
          <SheetPill label="Tipo" value={formatText(d.tipoCompensacion)} />
          <SheetPill label="Periodo" value={`${formatDate(d.periodoDesde)} → ${formatDate(d.periodoHasta)}`} icon="calendar" />
        </>}
      />

      <SheetSection title="Solicitud" icon="file-text">
        <SheetGrid>
          <SheetField label="Tipo de Compensación"       value={formatText(d.tipoCompensacion)} />
          <SheetField label="Periodo Desde"              value={formatDate(d.periodoDesde)} />
          <SheetField label="Periodo Hasta"              value={formatDate(d.periodoHasta)} />
          <SheetField label="Importe IT"                 value={formatCurrency(d.importeIT)} />
          <SheetField label="Razón Social Red Anterior"  value={formatText(d.razonSocialRedAnterior)} wide />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Liquidación" icon="euro">
        <SheetGrid>
          <SheetField label="Tipo de Liquidación"        value={formatText(d.tipoLiquidacion)} />
          <SheetField label="Número de Liquidación"      value={formatText(d.numeroLiquidacion)} />
          <SheetField label="Procedencia de Liquidación" value={formatText(d.procedenciaLiquidacion)} />
          <SheetField label="Descripción de Liquidación" value={formatText(d.procedenciaLiquidacionDescripcion)} />
          <SheetField label="Fecha de Pago/Ingreso"      value={formatDate(d.fechaPago)} />
          <SheetField label="Cuantía Económica Neto"     value={formatCurrency(d.cuantiaEconomicaNeto)} />
          <SheetField label="% de Retención"             value={formatText(d.retencion)} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default CompensacionSLD;
